<template lang="html">

  <section class="opt_labels">   
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="opt_labels_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3">Code:</div><input type="text" class="col-lg-3" v-model="codeFilter" placeholder="Code"/>
                <div class="col-lg-3">Label:</div><input type="text" class="col-lg-3" v-model="labelFilter" placeholder="Label"/>
              </div>
              <b-button variant="primary" v-b-toggle.opt_labels_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Languages</h4>
              <p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">
             
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="4"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-9"
                ></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-5">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.opt_labels_filters v-if="false"><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
                <b-button variant="primary mr-1" v-if="false"><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary" v-if="false"><i class="mdi mdi-file-import"></i>Import</b-button>
              </span>
            </div>
            <b-table ref="opt_labels_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > 
              <!-- ActiveLang Button -->
              <template v-slot:cell(activeButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">                 
                  <b-button v-if="!data.item.active" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Attiva Lingua" @click="curItem=data.item; toggleLanguageStatus(data.item,true)">
                    <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Disattiva Lingua" @click="curItem=data.item; toggleLanguageStatus(data.item,false)">
                    <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                </h4>
                </b-row>
              </template>

              <!-- ActiveLang Button -->
              <template v-slot:cell(deleteButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">                 
                   <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                    <i class="mdi mdi-delete"></i>
                  </b-button>
                </h4>
                </b-row>
              </template>    
            <!-- A custom formatted column -->
             <!-- A custom formatted column -->
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=data.item">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                    <i class="mdi mdi-delete"></i>
                  </b-button>
                </b-row>
              </template>
              <!-- A custom formatted column -->
              
            <b-tooltip target="tooltip-target-1" triggers="hover">                    
            </b-tooltip>

            </b-table>
            <b-modal id="opt-color-details" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <b-table ref="opt_labels_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > <!-- A custom formatted column -->
                       
            </b-table>
                </b-row>
             </b-container>
            </b-modal>
            <b-modal id="modal-edit" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.code" disabled/>
                  <div class="col-lg-3">Description*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.description"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Fallback Language:</div>
                  <b-form-select id="labelGroup-dd" v-model="curItem.fallbackLanguage" class="col-lg-3" v-if="curItem.code == 'en'" disabled="disabled" readonly="readonly" >
                  </b-form-select>
                  <b-form-select id="labelGroup-dd" v-model="curItem.fallbackLanguage" class="col-lg-3" v-if="curItem.code !== 'en'" >                    
                    <b-form-select-option v-for = "lg in allLanguagesCode" :value="lg" v-if="lg.code !== curItem.code">{{lg.code}}</b-form-select-option>
                  </b-form-select>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
             <b-modal id="modal-new" title="New Languages"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
               <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.code" />
                  <div class="col-lg-3">Description*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="newItem.description"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Fallback Language:</div>
                  <b-form-select v-model="newItem.fallbackLanguage" class="col-lg-3">
                    <b-form-select-option v-for = "lg in allLanguagesCode" :value="lg">{{lg.code}}</b-form-select-option>
                  </b-form-select>
                </b-row>              
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="createItem()">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style>
.expandableContent {
  transition: 300ms ease-out;
}
.closed {
  height: 0vh !important;
}

li.nav-item.active > a {
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(100, 100, 100, 0.5);
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
export default {
  name: 'opt_labels',
  methods: {
    expandItem(element){
      console.log(element)
      this.accordionManager()
    },
  accordionManager () {
    document.querySelectorAll('tr[role=row][data-pk]').forEach(el=>{     
      var tr = document.createElement('tr')
          tr.className = 'expandableContent closed';
      var td = document.createElement('td')
          td.setAttribute('colspan',6);
          td.style.backgroundColor = 'yellow';  

          tr.appendChild(td);
          el.parentNode.appendChild(tr);
          el.parentNode.insertBefore(el,tr)
    })
  },
    toggleLanguageStatus(item,visibilityValue) {
      var stato = (!visibilityValue) ? 'disattivare' : 'attivare'
      this.$bvModal.msgBoxConfirm('Vuoi '+stato+' '+item.description+'?', {
        title: 'Cambio Stato Lingua',
        okVariant: 'danger',
        okTitle: 'Procedi',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          item.active=visibilityValue;
          this.saveCurItem(item);         
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
    },
    saveCurItem(curItem) {
      window.curr = curItem
      this.setSpinnerStatus(true);
      var intLabObj = 
      {
        id: curItem.id, 
        code:curItem.code, 
        description: curItem.description, 
        active:curItem.active, 
        fallbackLanguage: curItem.fallbackLanguage,
        language2CharCode: curItem.language2CharCode,
        languageSimpleCode: curItem.languageSimpleCode, 
        default: curItem.default
        }  
        this.axios
        .put('/ccb/auth/fe/language/' + curItem.id, intLabObj ,this.authHeader)
        .then(response => {
          if(response.status == 200) {            
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
              this.refreshTable();
            })
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-edit');
        })
    },
    createItem() {
    var intLabObj = this.newItem;
    intLabObj = {active:true, code: this.newItem.code, description:this.newItem.description, fallbackLanguage:this.newItem.fallbackLanguage};
    if((intLabObj.code==null || intLabObj.description==null) || (intLabObj.code.trim()=="" || intLabObj.description.trim()=="")) {
      this.$bvModal.msgBoxOk("Inserisci tutti i campi obbligatori", {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
    }else{  
        this.setSpinnerStatus(true);
        this.axios
        .post('/ccb/auth/fe/language', intLabObj, this.authHeader)
        .then(response => {
          if(response.status == 200) {
            this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: true,
            centered: true
          })
          .then(value => {
            this.refreshTable();
          })
          }  
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-new');
        })
      }
    },
     deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare '+item.description+'?', {
        title: 'Elimina',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value){

          this.setSpinnerStatus(true);
          this.axios
          .delete('/ccb/auth/fe/language/' + item.id ,this.authHeader)
          .then(response => {
            this.setSpinnerStatus(false);
            this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
            .then(value => {
              this.refreshTable();
              this.curItem=null;
            })
          })  
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          }).finally(e=>{
            this.setSpinnerStatus(false);
          })        

        }
        
      })

    },
    search() { 
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
     var params = {
            optGroup: this.getCurLabelGroup, modelName: this.getCurModel, language: this.getCurLanguage, 
            page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, 
            label: this.labelFilter, code: this.codeFilter }
      
      this.axios
      .get('/ccb/auth/fe/language/allPaged' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
          this.totalRowsResult=response.data.totalElements;      
          this.setSpinnerStatus(false);    
          this.setSearchLanguageList(response.data.content)     
                         
          });
    },
    btnNew() {
      
    },
    refreshTable() {
      this.search();
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus',
      'setSearchLanguageList',
      'setCurLabelGroup'
      
    ])
  },
  props: ['action','activeGroup'],
  data () {
    return {
      allLanguages: [],
      allLanguagesCode: [],
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:10,
      sortBy:'code',
      sortDesc: false,
      curItem:null,
      newItem : {id:null, fallbackLanguage:null, language: null,  labelGroup: null, code : null ,label: null ,modelEnableRegexp: 'DEFAULT' , modelDisableRegexp: null},
      fields: [
               
        {
          key: 'code',
          label: 'Code',
          sortable: false
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false
        },
        {
          key: 'fallbackLanguage.code',
          label: 'Language Fallback',
          sortable: false
        },
         {
          key: 'activeButton',
          label: 'Active',
          sortable: false
        },
         {
          key: 'buttons',
          label: '',
          sortable: false
        }

      ],
      labelFilter: '',
      codeFilter: ''
    }
  },
  computed: {
    getAllLanguages(){
      return this.allLanguages;
    },
    items () {
      return (this.getSearchLanguageList && this.getSearchLanguageList.length) ? this.getSearchLanguageList : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',      
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'getSearchLanguageList',
      'getLabelGroupList',
      'authHeader',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel'
    ])
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        // alert('search')
        this.search();        
       }
     },
    items (oldValue, newValue) {

    },
     currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  mounted() {
    window.scoper = this
    if(this.$route.query.activeGroup && this.$route.query.activeGroup !=null){
          this.setCurLabelGroup(this.$route.query.activeGroup);        
        }

        this.search(); 
        this.axios
      .get('/ccb/auth/fe/language/langlist' ,  {
        ...this.authHeader}          
          )
          .then((response) => {
          this.allLanguagesCode=response.data;
          console.log(this.allLanguagesCode);
                         
          });       
       
    this.setCurApp('ccadm');
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
.table td,
.table th {
  max-width: 40vw !important;
  overflow: hidden;
  word-break: break-all;
}
</style>
